module.exports = __webpack_public_path__ + "img/stadtwerke-logo.75c19354.png";